export const CompanyStatus = {
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo'
}

export const CompanyStatusColors = {
  ACTIVE: 'var(--success)',
  INACTIVE: 'var(--danger)'
}
